import { render, staticRenderFns } from "./FollowModal.vue?vue&type=template&id=512b4f9a&scoped=true"
import script from "./FollowModal.vue?vue&type=script&lang=js"
export * from "./FollowModal.vue?vue&type=script&lang=js"
import style0 from "./FollowModal.vue?vue&type=style&index=0&id=512b4f9a&prod&lang=scss&scoped=true"
import style1 from "./FollowModal.vue?vue&type=style&index=1&id=512b4f9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512b4f9a",
  null
  
)

export default component.exports